import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgFacebookLogoLarge = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={100}
      height={100}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#src__com__yext__listingslaunchstorm__public__icons__facebook-logo-large_svg__a)">
        <path
          d="M50 85.72c19.725 0 35.715-15.99 35.715-35.715S69.725 14.291 50 14.291c-19.724 0-35.714 15.99-35.714 35.714 0 19.724 15.99 35.714 35.714 35.714Z"
          fill="#1977F3"
        />
        <path
          d="m63.902 60.331 1.582-10.326H55.58v-6.7c0-2.822 1.381-5.58 5.82-5.58h4.506v-8.789s-4.088-.698-7.996-.698c-8.156 0-13.49 4.942-13.49 13.897v7.87h-9.07v10.326h9.07v24.956c1.818.287 3.681.432 5.58.432 1.898 0 3.762-.15 5.58-.432V60.331h8.322Z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="src__com__yext__listingslaunchstorm__public__icons__facebook-logo-large_svg__a">
          <path
            fill="#fff"
            transform="translate(14.286 14.286)"
            d="M0 0h71.429v71.429H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default SvgFacebookLogoLarge;
